import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
`;

const Spinner = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid #eee;
  border-top-color: #ccc;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  opacity: 0.5;
`;

const MiniLoader = () => (
  <Wrapper>
    <Spinner />
  </Wrapper>
);

export default MiniLoader;
